"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFinalSlash = void 0;
function removeFinalSlash(string) {
    if (string.charAt(string.length - 1) == '/')
        return string.substring(0, string.length - 1);
    else
        return string;
}
exports.removeFinalSlash = removeFinalSlash;
